module.exports = __webpack_public_path__ + "8266d4b81a550b1f4e9ef547605d1eb2.pdf";